import { render, staticRenderFns } from "./IconFolderOpenOutline.vue?vue&type=template&id=b6fd4b18"
import script from "./IconFolderOpenOutline.vue?vue&type=script&lang=js"
export * from "./IconFolderOpenOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports